// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fg-9";
export var fulfillmentFormRail = "_fg-8";
export var headerTitleRow = "_fg-b";
export var orderDetailsWrapper = "_fg-6";
export var paymentInformationGrid = "_fg-g";
export var paymentSummaryColumn = "_fg-h";
export var shipmentContainer = "_fg-a";
export var shipmentDetailsMainPane = "_fg-7";
export var shipmentNavigationCard = "_fg-4";
export var shipmentNavigationRail = "_fg-2";
export var shipmentNavigationRailHeader = "_fg-3";
export var shipmentSummaryFact = "_fg-d";
export var shipmentSummaryGrid = "_fg-c";
export var shipmentSummaryMetadataRow = "_fg-e";
export var shipmentSummaryTags = "_fg-f";
export var shipmentWorkspace = "_fg-0";
export var shipmentWorkspaceContent = "_fg-5";
export var shipmentWorkspaceHeader = "_fg-1";